import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

const badgeVariants = cva(
  "inline-flex h-5 shrink-0 items-center gap-1 rounded-sm border px-1.5 text-xs font-medium whitespace-nowrap [&_svg]:size-3",
  {
    variants: {
      variant: {
        default: "border-transparent bg-fg/8 text-fg",
        accent: "border-transparent bg-accent-muted text-accent",
        success: "border-transparent bg-success/12 text-success",
        warning: "border-transparent bg-warning/12 text-warning",
        danger: "border-transparent bg-danger/12 text-danger",
        outline: "border-border bg-transparent text-fg-muted",
      },
      /** One of the eight categorical calendar/project hues. Overrides `variant`. */
      hue: {
        red: "border-cal-red-border bg-cal-red-bg text-cal-red-fg",
        orange: "border-cal-orange-border bg-cal-orange-bg text-cal-orange-fg",
        yellow: "border-cal-yellow-border bg-cal-yellow-bg text-cal-yellow-fg",
        green: "border-cal-green-border bg-cal-green-bg text-cal-green-fg",
        teal: "border-cal-teal-border bg-cal-teal-bg text-cal-teal-fg",
        blue: "border-cal-blue-border bg-cal-blue-bg text-cal-blue-fg",
        purple: "border-cal-purple-border bg-cal-purple-bg text-cal-purple-fg",
        pink: "border-cal-pink-border bg-cal-pink-bg text-cal-pink-fg",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export type BadgeHue = NonNullable<VariantProps<typeof badgeVariants>["hue"]>;

export interface BadgeProps extends ComponentProps<"span">, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, hue, ...props }: BadgeProps) {
  return (
    <span data-slot="badge" className={cn(badgeVariants({ variant, hue }), className)} {...props} />
  );
}
